exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".extra-img[data-v-55003dca] {\n  margin-top: -60px;\n  text-align: center;\n  width: 195px;\n}\n.extra-img img[data-v-55003dca] {\n  width: 100%;\n}\n.mobile .extra-img[data-v-55003dca] {\n  margin-top: 0;\n  text-align: center;\n  width: 96px;\n}\n.mobile .extra-img img[data-v-55003dca] {\n  width: 100%;\n}\n", ""]);

// exports
